<template>
  <div>
    <loading-component :value="loading_payment"></loading-component>
    <v-card>
      <v-card-title>
        <v-layout>
          <!-- <v-flex xs9 style="padding: 8px">
            <v-select
              label="Select Status"
              multiple
              :items="['PENDING', 'STAGING', 'APPROVED', 'PAID']"
              v-model="payment_status"
            ></v-select>
          </v-flex> -->
          <v-flex xs6 style="padding: 8px">
            <choose-date clearable :label="$t('reservationsPage.filterByDay')" v-model="date_filter"></choose-date>
          </v-flex>
          <!-- <v-flex xs6 style="padding: 8px">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              @keyup.enter="getData"
            ></v-text-field>
          </v-flex> -->
        </v-layout>
      </v-card-title>
      <v-data-table :url="url" :headers="headers" :items="data" :pagination.sync="pagination" :total-items="totalItems"
        :rows-per-page-items="[5, 10, 15, 25, 100, 300]" :loading="loading">
        <template v-slot:items="props">
          <tr @click="expandTable(props)" :class="{ row: props.item.transformed }">
            <td class="text-xs-center">{{ props.item.id }}</td>
            <td class="text-xs-center">
              {{ props.item.passenger_full_name }}
            </td>
            <td class="text-xs-center">
              {{ formatDate(props.item.datetime) }}
            </td>
            <td class="text-xs-center">
              {{ props.item.room_number }}
            </td>
            <td class="text-xs-center">
              <span v-if="props.item.landmark_pickup">{{
                props.item.landmark_pickup
              }}</span>
              <span v-else-if="props.item.pick_up_location_details">{{
                props.item.pick_up_location_details
              }}</span>
              <span v-else>{{ props.item.pick_up_location_name }}</span>
            </td>
            <td class="text-xs-center">
              <span v-if="props.item.landmark_dropoff">{{
                props.item.landmark_dropoff
              }}</span>
              <span v-else-if="props.item.pull_down_location_details">{{
                props.item.pull_down_location_details
              }}</span>
              <span v-else>{{ props.item.pull_down_location_name }}</span>
            </td>
            <td class="text-xs-center">
              {{ props.item.vehicle_type }}
            </td>

            <td class="text-xs-center">
              <span v-if="props.item.status === 'PAX_CANCELLED'">
                {{ $t("reservationsPage.statusPaxCancelled") }}
              </span>
              <span v-else-if="props.item.status === 'CAPTAIN_CANCELLED'">
                {{ $t("reservationsPage.statusCaptainCancelled") }}
              </span>
              <span v-else-if="props.item.status === 'SYSTEM_CANCELLED'">
                {{ $t("reservationsPage.statusSystemCancelled") }}
              </span>
              <!-- <span v-else>
                {{ props.item.status }}
              </span> -->
              <span v-else-if="props.item.status === 'PENDING'">
                {{ $t("reservationsPage.statusPending") }}
              </span>
              <span v-else-if="
                props.item.status === 'APPROVED' || props.item.status === 'ACCEPTED'
              ">
                {{ $t("reservationsPage.statusAccepted") }}
              </span>
              <span v-else-if="props.item.status === 'STARTED'">
                {{ $t("reservationsPage.statusStarted") }}
              </span>
              <span v-else-if="props.item.status === 'ARRIVED'"> {{ $t("reservationsPage.statusArrived") }} </span>
              <span v-else-if="props.item.status === 'PICKED_UP'"> {{ $t("reservationsPage.statusPickedUp") }} </span><span
                v-else-if="props.item.status === 'DONE'"> {{ $t("reservationsPage.statusDone") }} </span><span
                v-else-if="props.item.status === 'PAID'"> {{ $t("reservationsPage.statusPaid") }} </span>
              <span v-else-if="props.item.status === 'DELETED'"> {{ $t("reservationsPage.statusDeleted") }} </span>
              <span v-else>
                {{ props.item.status }}
              </span>
            </td>
            <td class="text-xs-center">
              <span v-if="props.item.taxi_number">{{ props.item.taxi_number }}</span>
              <span v-else>{{ $t("reservationsPage.noData") }}</span>
            </td>
            <!-- <td class="text-xs-center">{{ props.item.status }}</td> -->
            <td class="text-xs-center">
              <span style="color: red" v-if="props.item.transformed">{{ $t("reservationsPage.transformed") }}</span>
              <span style="color: green" v-else>{{ $t("reservationsPage.normal") }}</span>
            </td>
            <td class="text-xs-center">
              <!-- <v-btn color="green" flat @click="openDialog(props.item.id)" icon>
                <v-icon>check</v-icon>
              </v-btn>
              <v-btn color="blue" flat @click="stage(props.item.id)" icon>
                <v-icon>publish</v-icon>
              </v-btn> -->
              <!-- redistrbuteOrder(props.item.id) -->
              <div v-if="permission != 'Goverment'">
                <v-btn @click="dialog = true" icon flat color="#525252">
                  <v-icon>update</v-icon>
                </v-btn>
              </div>
              <div v-if="true">
                <div v-if="permission != 'Goverment'">
                  <v-btn v-if="
                    props.item.status == 'PENDING' ||
                    props.item.status == 'APPROVED' ||
                    props.item.status == 'ACCEPTED' ||
                    props.item.status == 'STARTED' ||
                    props.item.status == 'ARRIVED'
                  " @click="cancelOrder(props.item.id)" icon color="red" flat>
                    <v-icon>block</v-icon>
                  </v-btn>
                </div>
              </div>
              <div v-if="true">
                <div v-if="permission != 'Goverment'">
                  <v-btn v-if="
                    props.item.status == 'PENDING' ||
                    props.item.status == 'APPROVED' ||
                    props.item.status == 'ACCEPTED' ||
                    props.item.status == 'STARTED' ||
                    props.item.status == 'ARRIVED'
                  " @click="
                      editorder(
                        props.item.id,
                        props.item.pick_up_location_details,
                        props.item.pull_down_location_details,
                        props.item.datetime
                      )
                      " icon color="red" flat>
                    <v-icon>edit</v-icon>
                  </v-btn>
                </div>
              </div>
              <br />
              <div v-if="permission != 'Goverment'">
                <button class="material-icons" id="fb" @click="orderLogs(props.item.id)">
                  info
                </button>
              </div>
              <div>
                <button class="material-icons" @click="openDetails(props.item.id)">
                  calendar_view_week
                </button>
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:expand="props">
          <v-card flat>
            <v-container>
              <v-layout row wrap>
                <div class="constraint" v-if="props.item.seats">
                  <img :src="require(`../assets/constraints/person.svg`)" class="constraint-icon" />
                  <label class="name">{{ $tc("reservationsPage.seatsCount", props.item.seats, { count: props.item.seats }) }}</label>
                </div>
                <div class="constraint" v-if="props.item.encompt">
                  <img :src="require(`../assets/constraints/${constraints.en_compt}.svg`)"
                    class="constraint-icon" />
                  <label class="name">{{ $t("reservationsPage.constraintEncompte") }}</label>
                </div>
                <div class="constraint" v-if="props.item.low_car">
                  <img v-if="props.item.low_car" :src="require(`../assets/constraints/${constraints.low_car}.svg`)"
                    class="constraint-icon" />
                  <label class="name">{{ $t("reservationsPage.constraintLowCar") }}</label>
                </div>
                <div class="constraint" v-if="props.item.wheelchair">
                  <img v-if="props.item.wheelchair"
                    :src="require(`../assets/constraints/${constraints.wheelchair}.svg`)"
                    class="constraint-icon" />
                  <label class="name">{{ $t("reservationsPage.constraintWheelchair") }}</label>
                </div>
                <div class="constraint" v-if="props.item.pets">
                  <img v-if="props.item.pets" :src="require(`../assets/constraints/${constraints.animal}.svg`)"
                    class="constraint-icon" />
                  <label class="name">{{ $t("reservationsPage.constraintPets") }}</label>
                </div>
                <div class="constraint" v-if="props.item.amex">
                  <img v-if="props.item.amex" :src="require(`../assets/constraints/${constraints.amex}.svg`)"
                    class="constraint-icon" />
                  <label class="name">{{ $t("reservationsPage.constraintAmex") }}</label>
                </div>
                <div class="constraint" v-if="props.item.mad">
                  <img v-if="props.item.mad" :src="require(`../assets/constraints/${constraints.mad}.svg`)"
                    class="constraint-icon" />
                  <label class="name">{{ $t("reservationsPage.constraintMad") }}</label>
                </div>
                <div class="constraint" v-if="props.item.test">
                  <img v-if="props.item.test" :src="require(`../assets/constraints/${constraints.test}.svg`)"
                    class="constraint-icon" />
                  <label class="name">{{ $t("reservationsPage.constraintTest") }}</label>
                </div>
                <v-flex xs12 style="margin-bottom: 12px"><b>{{ $t("reservationsPage.comments") }} </b> {{ props.item.notes }}</v-flex>
                <!-- <v-flex xs12>{{ props }}</v-flex> -->
                <v-flex xs12><b>{{ $t("reservationsPage.creationDate") }} </b>{{ props.item.created_at }}</v-flex>
              </v-layout>
            </v-container>
          </v-card>
          <v-dialog v-model="dialog" max-width="390">
            <v-card>
              <v-card-title class="headline">{{ $t("reservationsPage.redistributeConfirm", { id: props.item.id }) }}</v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="primary" flat="flat" @click="dialog = false"> {{ $t("reservationsPage.no") }} </v-btn>
                <div v-if="permission != 'Goverment'">
                  <v-btn color="primary" flat="flat" @click="redistributeOrder(props.item.id)">
                    {{ $t("reservationsPage.yes") }}
                  </v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="diaload" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t("reservationsPage.savingChanges") }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cancellationDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline"> {{ $t("reservationsPage.cancellationReason") }} </span>
        </v-card-title>
        <v-card-text>
          <div v-for="option in userCancellationReasons" :key="option.id" class="radio-option">
            <input type="radio" :value="option.id" v-model="returnUserCancellationReason" :id="option.id"
              class="radio-input" />
            <label :for="option.id" class="radio-label">{{ option.text }}</label>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="cancellationDialog = false">{{ $t("reservationsPage.close") }}</v-btn>
          <v-btn color="primary" :loading="loading" flat @click="submitCancelOrder">{{ $t("reservationsPage.submit") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ChooseCaptainsMulti from "@/components/monaco/input/ChooseCaptainMulti";
import LoadingComponent from "@/components/LoadingComponent";
import ChooseDate from "@/components/monaco/input/ChooseDate";
import ConfirmDialog from "@/components/monaco/ConfirmDialog";
import api from "@/constants/api.js";
import { companyToday, formatCompanyTime } from "@/util/companyTime";

export default {
  name: "Reservations",
  title() {
    return this.$t("reservationsPage.pageTitle");
  },
  components: {
    ConfirmDialog,
    ChooseDate,
    LoadingComponent,
    ChooseCaptainsMulti,
  },
  data() {
    return {
      userCancellationReasons: [],
      cancellationDialog: false,
      returnUserCancellationReason: "",
      orderToCancel: null,
      permission: null,
      start: "",
      end: "",
      from: "",
      dialog: false,
      diaload: false,
      approve_one_confirm_dialog: false,
      approve_confirm_dialog: false,
      model: {
        actual_paid: {
          exist: false,
          amount: null,
        },
        paid_using: null,
      },
      constraints: {
        amex: "amex",
        animal: "animal",
        low_car: "low_car",
        en_compt: "en_compt",
        person: "person",
        wheelchair: "wheelchair",
        mad: "mad",
        test: "test",
      },
      select_date: false,
      date: null,
      date_filter: "",
      valid: false,
      url: "booking",
      captains: [],
      loading_payment: false,
      payment_status: ["PENDING"],
      data: [],
      loading: false,
      search: "",
      items: [],
      totalItems: 0,
      pagination: {
        sortBy: "id",
        rowsPerPage: 300,
      },
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t("reservationsPage.colId"), value: "id", sortable: false, align: "center" },
        {
          text: this.$t("reservationsPage.colClientName"),
          value: "captain_name",
          sortable: false,
          align: "center",
        },
        { text: this.$t("reservationsPage.colTime"), value: "Datetime", sortable: false, align: "center" },
        {
          text: this.$t("reservationsPage.colRoomNumber"),
          value: "room_number",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("reservationsPage.colPickup"),
          value: "pickup_landmark",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("reservationsPage.colDropoff"),
          value: "dropoff_landmark",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("reservationsPage.colVehicle"),
          value: "vehicle_type",
          sortable: false,
          align: "center",
        },
        { text: this.$t("reservationsPage.colStatus"), value: "status", sortable: false, align: "center" },
        {
          text: this.$t("reservationsPage.colTaxiNumber"),
          value: "taxi_number",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("reservationsPage.colType"),
          value: "transformed",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    date_filter() {
      console.log(this.date_filter);
      this.getData();
    },
  },
  mounted() {
    this.permission = this.$store.state.user.roles[0].name;
    // Final-version doc 2026-10-05: "today" is the company (Damascus) day,
    // not the PC's.
    var today = companyToday();
    this.start = today + " 00:00:00";
    this.end = today + " 23:59:59";
    this.getData();
  },
  methods: {
    formatDate(date) {
      return formatCompanyTime(date, "HH[h]m - DD/MM/YYYY");
    },
    formatDateTime(time) {
      return formatCompanyTime(time, "HH[h]m - DD[/]MM[/]YYYY");
    },
    openDetails(id) {
      this.$router.push({
        name: "Bookings",
        params: {
          id: id,
        },
      });
    },
    orderLogs(id) {
      this.$router.push({
        name: "BookingLog",
        params: {
          id: id,
        },
      });
    },
    editorder(id) {
      // this.edit = 1;
      const routeData = this.$router.resolve({
        name: "PhoneBooking",
        query: {
          show_order_list: false,
          id: id,
          // grouper: this.data.group_order,
          // date: this.data.datetime,
          edit: 1,
        },
      });
      window.open(routeData.href, "_blank");
    },
    rescheduleOrder(id, pickup, pulldown, datetime) {
      this.$dialova({
        title: this.$t("reservationsPage.changeTimeTitle", { id }),
        paragraph: pulldown
          ? this.$t("reservationsPage.changeTimeParagraph", {
              id,
              pickup,
              dropoff: pulldown,
              time: this.formatDateTime(datetime),
            })
          : this.$t("reservationsPage.changeTimeParagraphNoDropoff", {
              id,
              pickup,
              time: this.formatDateTime(datetime),
            }),
        loader: true,
        input: this.$t("reservationsPage.enterNewDatetime"),
        type: "time",
      }).then(({ close, value }) => {
        this.axios
          .put(`booking/${id}`, {
            datetime: `${formatCompanyTime(datetime, "YYYY-MM-DD")} ${value}`,
          })
          .then((res) => {
            window.getApp.$emit(
              "SHOW_TOAST",
              this.$t("reservationsPage.timeChanged", {
                id,
                from: this.formatDateTime(datetime),
                to: this.formatDateTime(
                  formatCompanyTime(datetime, "YYYY-MM-DD") + " " + value + ":00"
                ),
              }),
              "green"
            );
            datetime = res.data.data.datetime;
          })
          .catch((err) => {
            window.getApp.$emit("SHOW_TOAST", err, "red");
          })
          .finally(() => {
            close();
          });
        console.log(value);
      });
    },
    redistributeOrder(id) {
      this.dialog = false;
      this.diaload = true;
      this.axios
        .post(`redistribute/${id}`)
        .then(() => {
          window.getApp.$emit(
            "SHOW_TOAST",
            this.$t("reservationsPage.orderRedistributed", { id }),
            "green"
          );
          close();
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
        })
        .finally(() => {
          this.diaload = false;
        });
    },
    openDialog(payment_id) {
      this.selected_payment = payment_id;
      this.approve_one_confirm_dialog = true;
    },
    cancelOrder(id) {
      this.$store
        .dispatch("getUserCancellationReasons")
        .then((data) => {
          this.userCancellationReasons = data;
          this.orderToCancel = id;
          this.cancellationDialog = true;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    submitCancelOrder() {
      if (!this.orderToCancel)
        return;
      if (!this.returnUserCancellationReason) {
        window.getApp.$emit("SHOW_TOAST", this.$t("reservationsPage.chooseReason"), "red");
        return;
      }
      this.loading = true;
      this.axios
        .delete(api.ACTIONS.BOOKINGS + `/${this.orderToCancel}`, {
          params: {
            user_cancellation_reason_id: this.returnUserCancellationReason,
          },
        })
        .then(() => {
          window.getApp.$emit("SHOW_TOAST", this.$t("reservationsPage.orderCancelled", { id: this.orderToCancel }), "green");
          this.$emit("cancelled");
          this.getData();
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
        })
        .finally(() => {
          this.loading = false;
          this.cancellationDialog=false;
        });
    },
    expandTable(row) {
      // if (row.item.status === "PAID" || row.item.status === "APPROVED")
      row.expanded = !row.expanded;
    },

    getData() {
      this.loading = true;
      const params = new URLSearchParams();
      if (this.date_filter != "Invalid date" && this.date_filter) {
        this.start = moment(this.date_filter).format("YYYY-MM-DD HH:mm:ss");

        this.end = moment(this.date_filter)
          .format("YYYY-MM-DD HH:mm:ss")
          .replace("00:00:00", "23:59:59");

        console.log("START");
        console.log(this.start);
        console.log(this.end);
      }
      params.append("page", this.pagination.page);
      params.append("perPage", String(this.pagination.rowsPerPage));
      // params.append("sortBy", String(this.pagination.sortBy));
      // params.append("descending", String(this.pagination.descending));
      params.append("time", "RESERVATION");
      params.append("sortBy", "id");
      params.append("descending", true);
      params.append("from", this.start);
      params.append("to", this.end);
      params.append("reservations", true);

      // params.append("search", String(this.search));
      // params.append("status", String(this.payment_status));
      // if (this.date_filter) params.append("weekday", String(this.date_filter));
      this.axios
        .get(this.url, { params })
        .then((res) => {
          console.log("data");
          console.log(res);
          this.data = res.data.data.data;
          this.totalItems = res.data.data.total;
          this.pagination.rowsPerPage = Number(res.data.data.per_page);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err.message);
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.constraint {
  border: 1px;
  border-style: solid;
  padding: 5px;
  border-radius: 10px;
  box-shadow: 1px 1px;
  width: max-content;
  align-items: center;
  display: flex;
  margin-inline-end: 10px;
  margin-bottom: 15px;
}

.constraint-icon {
  float: inline-start;
}

.name {
  margin-inline-start: 5px;
}

.test {
  color: red;
}

#fb {
  margin-inline-end: 30px;
}

.radio-option {
  padding-inline-start: 30px;
  display: flex;
  align-items: center;
  margin: 10px 0;
  font-family: 'Poppins';
}

.radio-input {
  margin-inline-end: 10px;
  cursor: pointer;
  accent-color: #4caf50;
  /* Change color of the radio button in modern browsers */
}

.radio-label {
  font-size: 16px;
  cursor: pointer;
}
</style>
